import { filterProjectActivities } from '../util/FilterLogic.jsx';
import { blankFilter } from '../context/projectFilter.js';

export const parseLayoutFilter = (rawFilter) => {
	if (rawFilter && typeof rawFilter === 'object' && !Array.isArray(rawFilter)) {
		return { ...blankFilter, ...rawFilter };
	}
	try {
		if (rawFilter == null || rawFilter === '') {
			return { ...blankFilter };
		}
		return { ...blankFilter, ...JSON.parse(rawFilter) };
	} catch {
		return { ...blankFilter };
	}
};

const activityCodeTypeExists = (activityCodesTree, groupByActivityCode) => {
	if (groupByActivityCode == null || groupByActivityCode === '') {
		return false;
	}
	if (!activityCodesTree || Array.isArray(activityCodesTree)) {
		return false;
	}
	return groupByActivityCode in activityCodesTree || String(groupByActivityCode) in activityCodesTree;
};

export const withValidLayoutGrouping = (layoutFields, activityCodesTree) => {
	const viewType = layoutFields && layoutFields.ViewType ? layoutFields.ViewType : 'WBS List';
	const groupBy = layoutFields && layoutFields.GroupBy ? layoutFields.GroupBy : null;
	const groupByActivityCode = layoutFields && layoutFields.GroupByActivityCode != null && layoutFields.GroupByActivityCode !== ''
		? layoutFields.GroupByActivityCode
		: null;
	if (viewType === 'Group List' && groupBy === 'Activity Code' && !activityCodeTypeExists(activityCodesTree, groupByActivityCode)) {
		return {
			...layoutFields,
			ViewType: 'WBS List',
			GroupBy: null,
			GroupByActivityCode: null
		};
	}
	return {
		...layoutFields,
		ViewType: viewType,
		GroupBy: groupBy,
		GroupByActivityCode: groupByActivityCode
	};
};

export const PROJECT_LAYOUT_ACTION_TYPES = {
	PROJECT_LAYOUT_ADD: 'PROJECT_LAYOUT_ADD',
	PROJECT_LAYOUT_SET: 'PROJECT_LAYOUT_SET',
	PROJECT_LAYOUT_SAVE: 'PROJECT_LAYOUT_SAVE',
	PROJECT_LAYOUT_RENAME: 'PROJECT_LAYOUT_RENAME',
	PROJECT_LAYOUT_DELETE: 'PROJECT_LAYOUT_DELETE',
	PROJECT_LAYOUT_CHANGE_MODAL_INFO: 'PROJECT_LAYOUT_CHANGE_MODAL_INFO'
};

export const addLayout = ({ result, name }) => {
	return {
		type: PROJECT_LAYOUT_ACTION_TYPES.PROJECT_LAYOUT_ADD,
		payload: { result, name }
	};
};

export const setLayout = layoutId => {
	return {
		type: PROJECT_LAYOUT_ACTION_TYPES.PROJECT_LAYOUT_SET,
		payload: { layoutId }
	};
};

export const saveLayout = () => {
	return {
		type: PROJECT_LAYOUT_ACTION_TYPES.PROJECT_LAYOUT_SAVE,
		payload: {}
	};
};

export const renameLayout = name => {
	return {
		type: PROJECT_LAYOUT_ACTION_TYPES.PROJECT_LAYOUT_RENAME,
		payload: { name }
	};
};

export const deleteLayout = name => {
	return {
		type: PROJECT_LAYOUT_ACTION_TYPES.PROJECT_LAYOUT_DELETE,
		payload: {}
	};
};

export const setLayoutChangedModalInfo = infoObject => {
	return {
		type: PROJECT_LAYOUT_ACTION_TYPES.PROJECT_LAYOUT_CHANGE_MODAL_INFO,
		payload: { infoObject }
	};
};

export default (state, action) => {
	const { type, payload } = action;
	switch (type) {
		case PROJECT_LAYOUT_ACTION_TYPES.PROJECT_LAYOUT_ADD: {
			const {result, name} = payload;
			const {projectLayouts} = state;
			const newProjectLayouts = projectLayouts.concat({ Id: result.Id, Name: name, Filter: null });
			return {
				...state,
				projectLayouts: newProjectLayouts,
				projectLayoutId: result.Id
			};
		}
		case PROJECT_LAYOUT_ACTION_TYPES.PROJECT_LAYOUT_SET: {
			const { layoutId } = payload;
			const { projectLayouts } = state;
			const layout = projectLayouts.find(layout => layout.Id === layoutId);
			const newState = {
				...state,
				layoutChanged: false
			};

			if (layout) {
				const layoutCopy = withValidLayoutGrouping({...layout}, state.projectActivityCodesTree);
				newState.projectLayoutId = layoutId;
				newState.projectViewType = layoutCopy.ViewType;
				newState.projectGroupBy = layoutCopy.GroupBy;
				newState.projectGroupByActivityCode = layoutCopy.GroupByActivityCode;
				newState.projectFilter = layoutCopy.Filter && typeof layoutCopy.Filter === 'object'
					? layoutCopy.Filter
					: JSON.parse(JSON.stringify(blankFilter));
			} else {
				newState.projectLayoutId = null;
				newState.projectViewType = 'WBS List';
				newState.projectGroupBy = null;
				newState.projectGroupByActivityCode = null;
				newState.projectFilter = JSON.parse(JSON.stringify(blankFilter));
			}
			return {
				...newState,
				...filterProjectActivities(newState)
			};
		}
		case PROJECT_LAYOUT_ACTION_TYPES.PROJECT_LAYOUT_SAVE: {
			const {
				projectLayouts,
				projectLayoutId,
				projectFilter,
				projectViewType,
				projectGroupBy,
				projectGroupByActivityCode,
				projectMapGroupBy
			} = state;
			const layoutIndex = projectLayouts.findIndex(layout => layout.Id === projectLayoutId);
			const layout = Object.assign({}, projectLayouts[layoutIndex]);

			layout.Filter = projectFilter;
			layout.ViewType = projectViewType;
			layout.GroupBy = projectGroupBy;
			layout.GroupByActivityCode = projectGroupByActivityCode;
			layout.MapGroupBy = projectMapGroupBy;

			const newProjectLayouts = [...projectLayouts];
			newProjectLayouts[layoutIndex] = layout;
			return {
				...state,
				layoutChanged: false,
				projectLayouts: newProjectLayouts
			};
		}
		case PROJECT_LAYOUT_ACTION_TYPES.PROJECT_LAYOUT_RENAME: {
			const { name } = payload;
			const { projectLayoutId, projectLayouts } = state;
			const layoutIndex = projectLayouts.findIndex(layout => layout.Id === projectLayoutId);

			const newProjectLayouts = [...projectLayouts];
			newProjectLayouts[layoutIndex].Name = name;
			return {
				...state,
				projectLayouts: newProjectLayouts
			};
		}
		case PROJECT_LAYOUT_ACTION_TYPES.PROJECT_LAYOUT_DELETE: {
			const { projectLayoutId, projectLayouts } = state;
			const layoutIndex = projectLayouts.findIndex(layout => layout.Id === projectLayoutId);
			const newProjectLayouts = [...projectLayouts];
			newProjectLayouts.splice(layoutIndex, 1);

			const newState = {
				...state,
				layoutChanged: false,
				projectLayouts: newProjectLayouts,
				projectLayoutId: null,
				projectViewType: 'WBS List',
				projectGroupBy: null,
				projectGroupByActivityCode: null,
				projectFilter: JSON.parse(JSON.stringify(blankFilter))
			};
			return {
				...newState,
				...filterProjectActivities(newState)
			};
		}
		case PROJECT_LAYOUT_ACTION_TYPES.PROJECT_LAYOUT_CHANGE_MODAL_INFO: {
			const { infoObject } = payload;
			return {
				...state,
				layoutChangedModalInfo: infoObject
			};
		}
		default:
			console.log('action type not found: ', type);
			return state;
	}
};
